export const USER_COUNT_VIEWER_ROLES = ['admin', 'll', 'vp', 'rm', 'pm'];

export const canRenderUserCount = (role) => USER_COUNT_VIEWER_ROLES.includes(role);

export const getPropertyUserCardPath = (role) =>
  role === 'pm' ? '/property/properties' : '/user/property';

/** Admin landlords card: prod prefers GET /report/landlord over usercount fallbacks. */
export const resolveAdminLandlordCount = ({
  landlordCount,
  activeLandlordCount,
  userTableCount,
}) => {
  if (landlordCount != null && landlordCount !== '') {
    return landlordCount;
  }
  if (activeLandlordCount != null && activeLandlordCount !== '') {
    return activeLandlordCount;
  }
  return userTableCount ?? 0;
};
